module.exports = __webpack_public_path__ + "img/fdj.aafe3dd2.png";